import axiosInstance from './axiosInstance'

export interface FeishuBotItem {
  id: string
  key: string
  webhook: string
  keyword: string
  secret: string
  enabled: boolean
}

export interface FeishuBotPayload {
  key: string
  webhook: string
  keyword?: string
  secret?: string
  enabled?: boolean
}

export class FeishuBotApi {
  static async getList(): Promise<FeishuBotItem[]> {
    const response = await axiosInstance.get('/cms/v1/feishu-bot')
    return response.data.data.list || []
  }

  static async create(data: FeishuBotPayload): Promise<FeishuBotItem> {
    const response = await axiosInstance.post('/cms/v1/feishu-bot', data)
    return response.data.data.bot
  }

  static async update(id: string, data: FeishuBotPayload): Promise<FeishuBotItem> {
    const response = await axiosInstance.put(`/cms/v1/feishu-bot/${id}`, data)
    return response.data.data.bot
  }

  static async delete(id: string): Promise<void> {
    await axiosInstance.delete(`/cms/v1/feishu-bot/${id}`)
  }
}
